import { render, staticRenderFns } from "./CustomerTemplatesList.vue?vue&type=template&id=36a180f8&"
import script from "./CustomerTemplatesList.vue?vue&type=script&lang=js&"
export * from "./CustomerTemplatesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports